import React from "react";
import classnames from "classnames";
import Button from "@dhn/components/atoms/button";

export default function ButtonEnabled({
  status,
  onClick,
  ars = false,
  disabled = false,
  title,
}) {
  if (!ars) {
    return (
      <Button
        type="button"
        color={status ? "success" : "danger"}
        style={{ marginLeft: "5px" }}
        className="card-header-action"
        onClick={onClick}
        disabled={disabled}
        title={title}
      >
        <i
          className={classnames("fa", { "fa-ban": !status, "fa-check": status })}
        />
        {status && <>{" Activo"}</>}
        {!status && <>{" Inactivo"}</>}
      </Button>
    )
  } else {
    return (
      <Button
        type="button"
        color={status ? "danger" : "primary"}
        style={{ marginLeft: "5px" }}
        className="card-header-action"
        onClick={onClick}
      >
        <i
          className={classnames("fa", { "fa-ban": status, "fa-check": !status })}
        />
        {status && <>{" Fuera de Operaciónes"}</>}
        {!status && <>{" Cesar Operaciónes"}</>}
      </Button>
    );
  }
}
